import React, { Component } from 'react';
import * as _ from 'lodash'
import './style.css';

import State from '../State'
import Logic from '../Logic'

import SurveyQuestionAnswer from '../SurveyQuestionAnswer'
import ExclamationSymbol from '../ExclamationSymbol'
import CloseButtonIcon from '../CloseButtonIcon'

class SurveyQuestion extends Component {
  constructor(props) {
    super(props)

    this.handleQuestionClick = this.handleQuestionClick.bind(this)
  }

  handleQuestionClick() {
    State.action('toggleQuestionExpanded', {
      question: this.props.question
    })
  }

  render() {
    const question = this.props.question
    // console.log(question)
    const answers = _.map(question.answers, (answer, i) => {
      return <SurveyQuestionAnswer key={i} section={this.props.section} question={question} answer={answer} answerIndex={i} />
    })

    let answerRemarkText = State.ui.explore && question.answers[question.chosenAnswer].remark
    let answerRemark = State.ui.explore && answerRemarkText !== '' ? <div className="survey-section-answer-remark">{answerRemarkText}</div> : ''

    let flagged = Logic.questionIsFlagged(this.props.section.id, question.id, State.derived.flaggedQuestions) ? <ExclamationSymbol r="10" /> : ''
    let answered = question.chosenAnswer !== null

    let questionClassName = 'survey-section-question' + (question.expanded ? ' expanded' : '')

    let originalChosenAnswerText = question.originalChosenAnswer !== null && question.originalChosenAnswer !== question.chosenAnswer ? ` (was ${question.answers[question.originalChosenAnswer].text})` : ''
    let chosenAnswer = answered ? <div className="survey-section-question-chosen-answer">{question.answers[question.chosenAnswer].text} {originalChosenAnswerText}</div> : null

    let closeButton = question.expanded ? <CloseButtonIcon size={8} /> : null

    // <div className="survey-section-question-background-line"></div>

    return (
      <div className={questionClassName} onClick={this.handleQuestionClick} >
        <div className="close-button">{closeButton}</div>

        <div className="survey-section-question-text">{flagged}{question.text} {chosenAnswer}</div>
        <div className="survey-section-question-answers">{answers}</div>
        {answerRemark}
      </div>
    );
  }
}

export default SurveyQuestion;



// WEBPACK FOOTER //
// ./src/SurveyQuestion/index.js